import React, { useState } from "react";
import { Button, MainList, Main } from "components";

import { ReactComponent as PlatformIcon } from "icons/platform.svg";

import { sort, filters } from "./const/data";
import ModalDeletePrototype from "./components/ModalDeletePrototype";

const default_state = { type: null, data: null };

const PrototypesList = ({ history }) => {
  const [prototype_modal, setPrototypeModal] = useState(
    default_state
  );

  const onClose = () => setPrototypeModal(default_state);

  return (
    <Main
      page={{
        name: "Prototypy",
        icon: <PlatformIcon />,
        breadcrumbs: [
          {
            name: "Prototypy",
          },
        ],
        buttons: (
          <Button
            type="add"
            text="Dodaj prototyp"
            path="/prototypes/new"
          />
        ),
      }}>
      <MainList
        query_key="prototypes"
        api_path="/prototypes"
        sort_column="id"
        sort_direction="desc"
        sort={sort}
        filters={filters}
        handleNavigate={(item) =>
          history.push(`/prototypes/${item.id}`)
        }
        renderItem={({ id, name }) => (
          <>
            <td>{id}</td>
            <td>{name}</td>
          </>
        )}
        renderActions={(item) => [
          {
            type: "remove",
            handleClick: () =>
              setPrototypeModal({
                type: "remove",
                data: item,
              }),
          },
        ]}>
        {prototype_modal?.type === "remove" && (
          <ModalDeletePrototype
            handleClose={onClose}
            {...prototype_modal.data}
          />
        )}
      </MainList>
    </Main>
  );
};

export default PrototypesList;
